import { toast } from "react-toastify";
import ModalComponent from "..";
import { useUpdateEventStatusMutation } from "../../../redux/features/event/event.api";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { MiniHeader } from "../../typography/miniHeader";

export const ArchiveEventModal = ({
  open,
  handleClose,
  event,
  onSuccess,
}: ModalCompProps & {
  event: CreatedEvent;
  onSuccess: () => void;
}) => {
  const [updateStatus, { isLoading }] = useUpdateEventStatusMutation();

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-4">
        <Icon
          svg={"archive"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px] text-primary"
        />

        <div>
          <MiniHeader
            header={`Archive “${event.name}”`}
            subheader="Archiving this event would just keep out of your sight. It will not longer show on your upcoming and past events until you unarchive it."
          />
        </div>

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Archive Event"}
            type="submit"
            onClick={async () => {
              const resp = await updateStatus({
                id: event._id,
                payload: {
                  status: "archived",
                },
              });

              if (resp?.data?.status === "success") {
                onSuccess();
                toast.success(
                  <p>
                    Event archived&nbsp;&nbsp;&nbsp;
                    <a href="/settings" className="underline">
                      View in Settings
                    </a>{" "}
                  </p>,
                );
              }
            }}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"primary"}
          />
        </div>
      </div>
    </ModalComponent>
  );
};
